import __request__ from 'routing/request';
interface GraphRequestImpl {
    readonly tenant_id: string;
    readonly client_secret: unknown;
    readonly subscription_type: string;
    readonly client_id: string;
}
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
interface GraphCreateInputRequest {
    readonly tenant_id: string;
    readonly content_type: string[];
    readonly read_time_offset: number;
    readonly name: string;
    readonly client_secret: unknown;
    readonly subscription_type: string;
    readonly enable_throttling: boolean;
    readonly polling_interval: number;
    readonly client_id: string;
}
/**
 * Validate input credentials
 */
export function checkCredentials(JSONbody: GraphRequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.microsoftgraph.api.GraphResource/microsoft_graph/check_credentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new Microsoft Graph input
 */
export function create(JSONbody: GraphCreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.microsoftgraph.api.GraphResource/microsoft_graph/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
